import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header/Logo-media/Header';
import Fotter from './Footer/Footer';

const MainLayout = () => {
  // State for search is now managed by the layout
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <>
      <Header setSearchTerm={setSearchTerm} />
      {/* Outlet renders the component for the current route */}
      <Outlet context={{ searchTerm }} />
      <Fotter />
    </>
  );
};

export default MainLayout;